<template>
  <v-card class="compare-highlight-card pa-6 h-100" elevation="0" border rounded="xl">
    <slot />
  </v-card>
</template>

<style scoped>
.compare-highlight-card {
  background: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
  border-color: rgb(var(--v-theme-primary));
}
</style>
